import { API_BASE_URL, ENDPOINTS } from "@/api/endpoints.js";

/**
 * Opts the recipient out of an organization's win-back emails, from the email link token.
 * Effectful POST (an email scanner pre-loading the link cannot unsubscribe). Returns 204 (no body).
 */
export const unsubscribeFromCampaign = async (token) => {
    const res = await fetch(`${API_BASE_URL}${ENDPOINTS.PUBLIC.CAMPAIGN_UNSUBSCRIBE}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ token }),
    });

    if (!res.ok) {
        const body = await res.text();
        try {
            throw new Error(JSON.parse(body).message || `Erreur ${res.status}`);
        } catch {
            throw new Error(body || `Erreur ${res.status}`);
        }
    }
};
